import { Dispatch } from "redux";
import { setOrganizationInvitationDetails, setOrganizationInvitationDetailsLoading } from "@redux/actions/organization-invitation-details-actions";
import { FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";
import { getAxnAdminUserInvitationRequest } from "@requests/axnadmin-core/get-axn-admin-user-invitation";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { formatAxnAdminUserInvitation } from "@formatters/axn-admin-user-invitations/axn-admin-user-invitation-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getOrganizationInvitationDetailsReduxRequest = (dispatch: Dispatch) => async (
    axnAdminUserInvitationId: string,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): Promise<FormattedAxnAdminUserInvitation> => {
    dispatch(setOrganizationInvitationDetailsLoading(true));
    const { data, error } = await getAxnAdminUserInvitationRequest(axnAdminUserInvitationId);
    if (data) {
        const formattedAxnAdminUserInvitations = formatAxnAdminUserInvitation(
            data,
            axnAdminUserPropertyBundles,
            axnCompanies,
            axnRelyingParties
        );
        dispatch(setOrganizationInvitationDetails(formattedAxnAdminUserInvitations));
        return formattedAxnAdminUserInvitations;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizationInvitationDetails.error.title,
                resources.requests.getOrganizationInvitationDetails.error.message
            );
        }
        dispatch(setOrganizationInvitationDetailsLoading(false));
        return null;
    }
};